<template>
  <v-card flat>
    <v-overlay :value="LigneRobIsLoading">
      <v-progress-circular indeterminate size="100" />
    </v-overlay>
    <v-card-text>
      <home-com />
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import homeCom from "@/components/homeCom";

export default {
  name: "VueHome",
  components: {
    homeCom,
  },
  computed: {
    ...mapGetters({
      LigneRobIsLoading: "ligneRobCom/list/isLoading",
    }),
  },
};
</script>

<style scoped></style>
